<template>
  <v-layout column fill-height mt-2 mx-3>
    <v-data-table
      :headers="headers"
      :items="studentTrays"
      class="elevation-1"
      hide-actions
      :loading="loadingData">
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="props">

        <td class="title text-xs-center"> {{ dateTrays(props.item.date) }} </td>

        <td class="pa-2">
          <trays-flickity
            :pictures="trayPicturesToShow(props.item.meals, 'lunch')"
            :imageAlign="['ml-2']"
            />
        </td>

        <td class="pa-2">
          <trays-flickity
            :pictures="trayPicturesToShow(props.item.meals, 'dinner')"
            :imageAlign="['ml-2']"
            />
        </td>
      </template>

      <template v-slot:no-data>
        <v-alert v-if="errorRequest" :value="true" color="error" icon="warning">
          Não foi possível buscar por bandejas!
        </v-alert>
        <v-alert v-else :value="true" color="warning" icon="warning">
          Não há bandejas cadastradas para o período selecionado!
        </v-alert>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import TraysFlickity from './TraysFlickity'
import { formatTimestamp } from '@/helpers/formatTimestamp'
/**
 * @group Meal Control
 * Controla a estrutura de visualização padrão para
 * principalmente desktop mostrando uma datatable com as
 * bandejas. Observação: É um subcomponente de [MealCard](/components/MealCard).
 */
export default {
  name: 'TraysDefaultList',

  components: {
    TraysFlickity
  },

  props: {
    // Controla o status de erro ao buscar informações
    errorRequest: {
      type: Boolean,
      default: false
    },
    // Controla o status de carregamento de informações
    loadingData: {
      type: Boolean,
      default: false
    },
    // Lista das bandejas dos estudantes
    studentTrays: {
      type: Array,
      // []
      default () { return [] }
    }
  },

  computed: {
    headers () {
      return [{
        text: 'Data',
        align: 'center',
        sortable: false,
        value: 'date',
        class: 'title',
        width: '20%'
      },
      {
        text: 'Almoço',
        align: 'center',
        sortable: false,
        value: 'lunch',
        class: 'title',
        width: '40%'
      },
      {
        text: 'Janta',
        align: 'center',
        sortable: false,
        value: 'dinner',
        class: 'title',
        width: '40%'
      }]
    }
  },

  methods: {
    /** @vuese
     * Chama helper de formatação de datas
     * @arg O argumento é a data que será formatada
     */
    dateTrays (dateValue) {
      const formatDate = 'DD/MM/YYYY'
      return formatTimestamp(dateValue, formatDate)
    },
    /**
     * @vuese
     * Usado para formatar imagens que serão passadas para TrayFlickity
     * @arg Recebe o array de refeições e a refeição desejada
     */
    trayPicturesToShow (meals = [], mealType) {
      const mealTypeToFind = meal => meal.meal_type === mealType
      const traysOfCurrentMeal = meals.find(mealTypeToFind) || {}

      return traysOfCurrentMeal.pictures || []
    }
  }
}
</script>
